import { mapState } from 'vuex';
export default {
  name: 'accountBase',
  data() {
    return {
      loading: false,
      accountFrom: {
        skill: this.$t('闪电五连鞭'),
        imgUrl: ''
      },
      skillList: ['闪电五连鞭', '偷袭', '耗子尾汁', '乌鸦坐飞机', '龙卷风摧毁停车场', '奥利给', '好嗨哟', '是个狼人', '雨女无瓜', '996']
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    }),
    accountRule() {
      return {
        imgUrl: [{
          required: true,
          trigger: 'blur'
        }],
        username: [{
          required: true,
          trigger: 'blur',
          message: '用户名不能为空！'
        }],
        position: [{
          required: true,
          trigger: 'blur',
          message: '职位不能为空！'
        }],
        location: [{
          required: true,
          trigger: 'blur',
          message: '请选择所在城市！'
        }],
        label: [{
          required: true,
          trigger: 'blur',
          message: '个人介绍不能为空！'
        }],
        skill: [{
          required: true,
          trigger: 'blur',
          message: '请至少勾选一项技能'
        }]
      };
    }
  },
  mounted() {
    this.accountFrom = this.accountInfo;
    this.accountFrom.imgUrl = require('../../../../assets/nav/user.gif');
  },
  methods: {
    changeSkill(key) {
      this.accountFrom.skill = key.join(',');
    },
    updateValue() {
      this.$refs.accountFrom.validate(valid => {
        if (valid) {
          this.loading = true;
          const {
            username,
            position,
            location,
            label,
            skill,
            role
          } = this.accountFrom;
          this.$store.dispatch('user/updateInfo', {
            username,
            position,
            location,
            label,
            skill,
            role
          }).then(() => {
            this.$message.success('修改成功！');
            this.loading = false;
          });
        }
      });
    },
    resetFrom() {
      this.$refs.accountFrom.resetFields();
    }
  }
};